module.exports = __webpack_public_path__ + "img/55800.e3d37cf6.jpg";